import { AbstractInterface } from './AbstractInterface';

/*
 * This interface forwards theme relevant functionality from Navigator to the third party mediator dervice.
 */
export class Theme extends AbstractInterface {

  /*
   * Sets the active theme.
   */
  public static setActive(theme: string): void {
    this.mediator.setActiveTheme(theme);
  }
}
